import { createContext } from 'preact/compat';
export const configDefaults = {
    component: 'basket',
    emptyTitle: 'Basket is empty',
    upsellSwiper: false,
    upsellBreakpoint: 759,
    termsAndConditionsUrl: '/terms-and-conditions',
    submissionEndpoint: 'https://snowdome.co.uk',
    termsTitle: 'Terms & Conditions for recreational activities',
    termsSubheading: 'Please read the following and accept below:',
    termsContent: '',
    termsShowCheckbox: false,
    hideQuickPayButtons: false,
    darkQuickPayButtons: false,
    isModal: false,
    basketPage: '/basket',
    basketTitle: 'Basket',
    basketIcon: 'basket',
    basketId: '.basket-menu',
    items: [],
    misc: [],
    upsells: [],
    emptyImage: {
        src: 'https://placehold.co/750x300/png',
        alt: undefined,
    },
    emptyLink: {
        text: 'Start Your Adventure',
        link: '/homepage.html',
    },
    paymentIcons: [
        {
            src: 'https://placehold.co/98x32',
        },
        {
            src: 'https://placehold.co/72x56',
        },
        {
            src: 'https://placehold.co/92x44',
        },
        {
            src: 'https://placehold.co/98x40',
        },
    ],
    termsTextCopy: 'By proceeding you agree to the',
    termsTextLink: 'Terms & Conditions',
    paymentCompleteTitle: 'Thanks for your booking',
    paymentCompleteCopy: undefined,
    requiresSignature: false,
};
export const ConfigCTX = createContext(configDefaults);
